import { IExtractedField } from 'types/db/ExtractedProForma';
import { ForecastMetricId } from '../../layout/metrics';
import { BlockResolver } from '../../layout/types';
import { buildFieldMap, extractedCell, hasDataWithPrefix } from './cells';

export const extractedForecastResolver = (fields: IExtractedField[]): BlockResolver<ForecastMetricId> => {
    const fieldMap = buildFieldMap(fields);

    return {
        hasData: () => hasDataWithPrefix(fieldMap, 'forecast.'),

        netSaleProceeds: extractedCell(fieldMap, 'forecast.net_sale_proceeds'),
        permanentLoanPayoff: extractedCell(fieldMap, 'forecast.permanent_loan_payoff'),
        equityProceedsFromSale: extractedCell(fieldMap, 'forecast.equity_proceeds_from_sale'),
        cashOnCashReturn: extractedCell(fieldMap, 'forecast.cash_on_cash_return'),
        debtServiceCoverageRatio: extractedCell(fieldMap, 'forecast.debt_service_coverage_ratio'),
        operatingExpenseRatio: extractedCell(fieldMap, 'forecast.operating_expense_ratio'),
        breakevenOccupancy: extractedCell(fieldMap, 'forecast.breakeven_occupancy'),
    };
};
